import * as React from "react";
import PopDetail from "../popdetail";
import CreateService from "../../service/create";
import Wait from "../wait";

export default class AddDocumentPane extends React.Component{

    constructor(props) {
        super(props)

        this.state = {
            description:this.props.document.description
        }
        this.handleChanges = this.handleChanges.bind(this)
        this.handleFileChanges = this.handleFileChanges.bind(this)
        this.submit = this.submit.bind(this)
    }
    componentDidMount() {
        this.setState({
            description:this.props.document.description
        })
    }


    handleChanges=(e)=>{ this.setState({[e.target.name]:e.target.value}) }
    handleFileChanges = async (event) => { await this.setState({[event.target.name]: event.target.files[0]}) }

    submit(){


        let formdata = new FormData()
        formdata.append('project_id',this.props.project.id)
        formdata.append('description',this.state.description)
        formdata.append('document_type_id',this.props.document.id)
        formdata.append('file',this.state.file)
        formdata.append('task_id',this.props.taskId)
        formdata.append('screen_code',this.props.screen_code)
        formdata.append('locality_id',this.props.document.locality.id)

        Wait.show('Uploading...')
        CreateService.uploadFile('projects/documents/create',formdata).then(r  =>{
            try {
                Wait.dismiss()
                this.props.loadData()
                PopDetail.dismiss()
                /*if (r.data.status===1){
                    Wait.dismiss()
                    this.props.loadData()
                    PopDetail.dismiss()
                    return
                }
                alert(r.data.message)*/
            }catch (e) {
                console.log(e)
            }
        })
    }
    render() {
        return(<div style={{padding:'32px'}}>
            <div className={'col col-sm-12'}>
                <table style={{width:'100%'}}>
                    <tbody>
                    <tr>
                        <td className={'label'} style={{width:'200px'}}>
                            Locality Name :
                        </td>
                        <td>
                            <input style={{width:'100%'}} defaultValue={this.props.document.locality.name} disabled={true}/>
                        </td>
                    </tr>
                    <tr>
                         <td className={'label'}>
                            Document Type :
                        </td>
                        <td>
                            <input style={{width:'100%'}} defaultValue={this.props.document.name} disabled={true}/>
                        </td>
                    </tr>
                    <tr>
                       <td className={'label'}>
                            Document Description :
                        </td>
                        <td>
                            <textarea  style={{width:'100%'}} defaultValue={this.props.document.description} name={'description'} onChange={this.handleChanges}/>
                        </td>
                    </tr>
                    <tr>
                       <td className={'label'}>
                            Document Path :
                        </td>
                        <td>
                            <input type={'file'} name='file' style={{width:'100%'}} onChange={this.handleFileChanges} accept={this.props.document.accept}/>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2}>
                            <hr/>
                        </td>
                    </tr>
                    <tr>
                        <td/>

                        <td>
                            <button className={'btn submit'} onClick={this.submit}>Submit</button>
                            <button className={'btn error'} onClick={()=>PopDetail.dismiss()}>{/*onClick={()=>VillageDocumentPane.showAddDoc(false)}>*/}
                                <span className={'fa fa-times'}/>Close
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>


            </div>
        </div>)
    }
}